<template>
  <div class="p-l-15 p-r-15">
    <legend class="f-s-13 p-b-10 p-l-0">
      <span v-t="'API_TOKENS_USAGE_HISTORY'" />
      <button
        type="button"
        class="btn btn-xs btn-danger legend-right-button"
        @click="hideUsage"
      >
        <i aria-hidden="true" class="fa fa-close" />
        {{ $t('CLOSE') }}
      </button>
    </legend>
    <div class="p-b-5">
      <v-table
        :data="usage"
        :current-page.sync="currentPage"
        :page-size="10"
        :hide-sort-icons="true"
        class="table_beauty"
        @totalPagesChanged="totalPages = $event"
      >
        <thead slot="head">
          <tr>
            <v-th
              default-sort="asc"
              sort-key="loginTime"
              v-t="'API_TOKENS_USAGE_DATE'"
            />
            <v-th
              sort-key="protectedResource"
              v-t="'API_TOKENS_USAGE_RESOURCE'"
            />
            <v-th
              sort-key="ipAddress"
              v-t="'API_TOKENS_USAGE_IP'"
            />
          </tr>
        </thead>
        <tbody
          slot="body"
          slot-scope="{ displayData }"
        >
          <tr v-if="displayData.length === 0">
            <td colspan="3" v-t="'API_TOKENS_HEADER_USAGE_NONE'" />
          </tr>
          <tr
            v-for="row in displayData"
            :key="row.id"
          >
            <td>{{ row.loginTime }}</td>
            <td>{{ row.protectedResource }}</td>
            <td>{{ row.ipAddress }}</td>
          </tr>
        </tbody>
      </v-table>
      <div class="pagination-min">
        <div class="text-center p-7">
          <smart-pagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'ApiTokenUsage',
  props:{
    usage: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 0
    }
  },
  methods:{
    hideUsage() {
      this.$emit('hideUsage');
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>